import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Clock } from 'lucide-react';
import { ScrollButton } from './ui/ScrollButton';
export const HeroSection = () => {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden pt-8 pb-6 sm:pt-24 sm:pb-24 bg-cream" data-id="element-133">
      <div className="container relative mx-auto px-4" data-id="element-134">
        <div className="mx-auto max-w-4xl text-center" data-id="element-135">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mb-2 sm:mb-6 inline-flex items-center gap-2 rounded-full border border-brand-200 bg-brand-50 px-3 py-1 sm:px-4 sm:py-1.5 text-[11px] sm:text-sm font-semibold text-brand-700" data-id="element-136">
            <span className="relative flex h-2 w-2" data-id="element-137">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-400 opacity-75" data-id="element-138"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-500" data-id="element-139"></span>
            </span>
            ⚠️ PROFESIONALES INDEPENDIENTES — ARGENTINA 2026
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="mb-3 sm:mb-6 tracking-tight text-[28px] leading-[1.1] sm:text-6xl lg:text-7xl text-balance text-neutral-900 font-[600] font-[Merriweather,_serif]" data-id="element-140">
            Cada día sin un sistema, perdés clientes que no vuelven.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="mx-auto mb-4 sm:mb-10 max-w-2xl text-sm leading-snug sm:text-xl text-neutral-600 text-balance" data-id="element-141">
            Los que hoy te dicen "dejame pensarlo" mañana le pagan a otro.{' '}
            <strong className="text-neutral-900 font-semibold" data-id="element-142">
              Este manual te da las palabras exactas para que te paguen a vos.
            </strong>
          </motion.p>

          {/* Book Cover */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="flex mb-4 sm:mb-12 justify-center" data-id="element-143">
            <div onClick={scrollToCompra} className="relative cursor-pointer transition-transform hover:scale-[1.02] group" style={{
            perspective: '1200px'
          }} data-id="element-144">
              {/* Book shadow */}
              <div className="absolute -bottom-1.5 sm:-bottom-4 left-2 right-2 sm:left-4 sm:right-4 h-3 sm:h-8 bg-neutral-900/10 blur-xl rounded-full" data-id="element-145" />

              {/* Book spine effect */}
              <div className="absolute left-0 top-0 bottom-0 w-2 sm:w-4 bg-brand-800 rounded-l-md z-10 shadow-inner" data-id="element-146" />

              {/* Main cover */}
              <div className="relative w-[140px] sm:w-[320px] md:w-[420px] aspect-[3/4] bg-gradient-to-br from-brand-700 via-brand-600 to-brand-700 rounded-r-lg rounded-l-sm shadow-2xl overflow-hidden ml-0.5 sm:ml-1" data-id="element-147">
                {/* Subtle texture overlay */}
                <div className="absolute inset-0 opacity-[0.04]" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")"
              }} data-id="element-148" />

                <div className="absolute top-0 left-0 right-0 h-0.5 sm:h-1 bg-brand-300/40" data-id="element-149" />

                <div className="relative z-10 flex flex-col items-center justify-between h-full px-2 sm:px-12 py-2 sm:py-14 text-center" data-id="element-150">
                  {/* Top section - hidden on mobile for space */}
                  <div className="hidden sm:block space-y-4" data-id="element-151">
                    <div className="w-16 h-px bg-brand-300/50 mx-auto" data-id="element-152" />
                    <p className="text-brand-200/80 text-sm font-sans uppercase tracking-[0.3em] font-medium" data-id="element-153">
                      Manual Táctico · 2026
                    </p>
                    <div className="w-16 h-px bg-brand-300/50 mx-auto" data-id="element-154" />
                  </div>

                  {/* Center — Title */}
                  <div className="space-y-0.5 sm:space-y-6 flex-1 flex flex-col items-center justify-center" data-id="element-155">
                    <h2 className="text-lg sm:text-6xl md:text-7xl font-bold text-white leading-[0.9] tracking-tight" style={{
                    fontFamily: 'Merriweather, serif'
                  }} data-id="element-156">
                      CAJA
                      <br data-id="element-157" />
                      <span className="text-brand-200 text-base sm:text-6xl md:text-7xl" data-id="element-158">
                        DE
                      </span>
                      <br data-id="element-159" />
                      COBRO
                    </h2>

                    {/* Decorative divider - hidden on mobile */}
                    <div className="hidden sm:flex items-center gap-3" data-id="element-160">
                      <div className="w-8 h-px bg-brand-300/60" data-id="element-161" />
                      <div className="w-2 h-2 rotate-45 border border-brand-300/60" data-id="element-162" />
                      <div className="w-8 h-px bg-brand-300/60" data-id="element-163" />
                    </div>

                    {/* Slogan */}
                    <p className="text-brand-100 text-[10px] sm:text-xl italic font-display" data-id="element-164">
                      "El Mercado Cambió"
                    </p>
                  </div>

                  {/* Bottom section - hidden on mobile */}
                  <div className="hidden sm:block space-y-3" data-id="element-165">
                    <div className="w-24 h-px bg-brand-300/40 mx-auto" data-id="element-166" />
                    <p className="text-brand-300/70 text-xs font-sans uppercase tracking-[0.25em]" data-id="element-167">
                      Sistema de Ventas
                    </p>
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 h-0.5 sm:h-1 bg-brand-300/40" data-id="element-168" />
                <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-white/[0.06] to-transparent pointer-events-none" data-id="element-169" />
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mx-auto max-w-3xl rounded-xl border border-neutral-200 bg-white p-4 sm:p-8 shadow-sm" data-id="element-170">
            <p className="mb-3 sm:mb-8 text-[13px] sm:text-xl font-medium text-neutral-700 leading-snug" data-id="element-171">
              Palabras exactas para reactivar clientes, cerrar presupuestos y
              cobrar — incluso en el contexto más difícil.
            </p>

            <ScrollButton className="w-full sm:w-auto sm:px-12 py-2.5 sm:py-5 text-sm sm:text-xl mb-3 sm:mb-6" data-id="element-172">
              👇 QUIERO MI CAJA DE COBRO AHORA
            </ScrollButton>

            <div className="hidden sm:flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm font-medium text-neutral-500" data-id="element-173">
              <span className="flex items-center gap-1" data-id="element-174">
                <Clock className="h-4 w-4 text-brand-600" data-id="element-175" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-176">
                <Download className="h-4 w-4 text-brand-600" data-id="element-177" /> Descarga
                instantánea
              </span>
              <span className="flex items-center gap-1" data-id="element-178">
                <ShieldCheck className="h-4 w-4 text-brand-600" data-id="element-179" /> Garantía 7
                días
              </span>
            </div>
            <p className="sm:hidden text-[10px] text-center text-neutral-400 font-medium" data-id="element-180">
              Acceso inmediato · Descarga instantánea · Garantía 7 días
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};